// src/utils/debug.js
// Sistema de debug condicional - só mostra logs para administradores

const isAdmin = () => {
    try {
        const roleId = parseInt(localStorage.getItem('role_id') || '0', 10);
        return roleId === 1;
    } catch {
        return false;
    }
};

export const debugLog = (...args) => {
    if (isAdmin()) {
        console.log(...args);
    }
};

export const debugWarn = (...args) => {
    if (isAdmin()) {
        console.warn(...args);
    }
};

export const debugError = (...args) => {
    if (isAdmin()) {
        console.error(...args);
    }
};

// Para production, você pode usar process.env.NODE_ENV
export const isDevelopment = () => {
    return process.env.NODE_ENV === 'development';
};
